import { Progress, Box, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ROUTE_NAMES } from "@root/constants";
import { useNavigate } from "react-router-dom";

interface CourseLayoutProps {
  name: string;
  completed: number;
  id: any;
}

export const CourseLayout = ({ name, completed, id }: CourseLayoutProps) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const roundedCompleted = parseFloat(completed.toFixed(2));

  const getProgressColor = () => {
    if (roundedCompleted === 100) return "green";
    if (roundedCompleted > 0) return "yellow";
    return "gray";
  };

  return (
    <Box
      borderRadius="8px"
      border="1px solid #CDD6DC"
      p={{ base: "10px 12px", md: "12px 16px" }}
      width="100%"
      mb="8px"
    >
      {/* Course name */}
      <Text
        fontSize={{ base: "13px", md: "14px" }}
        fontWeight={500}
        lineHeight="1.3"
        mb={{ base: "8px", md: "10px" }}
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {name}
      </Text>

      {/* Progress + button in one row */}
      <Flex align="center" gap={{ base: "8px", md: "12px" }}>
        <Progress
          value={roundedCompleted}
          colorScheme={getProgressColor()}
          height={{ base: "8px", md: "10px" }}
          flex="1"
          borderRadius="8px"
          minWidth={0}
        />
        <Text
          fontSize={{ base: "12px", md: "12px" }}
          fontWeight={400}
          color="#5C6670"
          minW={{ base: "34px", md: "38px" }}
          textAlign="right"
          flexShrink={0}
        >
          {roundedCompleted}%
        </Text>
        {roundedCompleted !== 100 ? (
          <Box
            as="button"
            onClick={() =>
              navigate(`${ROUTE_NAMES.JOURNALIST_COURSE_DETAIL}/${id}`)
            }
            bg="transparent"
            color="#1819B4"
            border="1px solid #1819B4"
            borderRadius="8px"
            px={{ base: "10px", md: "12px" }}
            py={{ base: "5px", md: "6px" }}
            fontSize={{ base: "12px", md: "14px" }}
            fontWeight={500}
            cursor="pointer"
            whiteSpace="nowrap"
            flexShrink={0}
            _hover={{ bg: "#1819B4", color: "white" }}
            transition="all 0.2s"
          >
            {t("kpecDashboard.continue")}
          </Box>
        ) : (
          <Box
            bg="#00A1771A"
            color="#00A177"
            border="1px solid #00A177"
            borderRadius="20px"
            px={{ base: "10px", md: "12px" }}
            py={{ base: "5px", md: "6px" }}
            fontSize={{ base: "12px", md: "14px" }}
            fontWeight={500}
            textAlign="center"
            whiteSpace="nowrap"
            flexShrink={0}
          >
            {t("kpecDashboard.completed")}
          </Box>
        )}
      </Flex>
    </Box>
  );
};
